import UrlService from '../../../services/UrlService';
import { SUBMIT_GENERATE_REPORT } from '../vehicleDetails';

export const generateMonitoringOrdersCo2EmissionReport = (requestParams) => ({
  type: SUBMIT_GENERATE_REPORT.START,
  payload: {
    request: {
      method: 'get',
      responseType: 'blob',
      url: UrlService.generateMonitoringOrdersCo2EmissionReport(),
      params: requestParams,
    },
  },
});
